import React, { useEffect, useState } from "react";
import {
  TextInput,
  Select,
  SelectItem,
  Dropdown,
  Button,
  PasswordInput,
  Link,
  InlineNotification,
  Modal,
  Accordion,
  AccordionItem,
  Form,
  ToastNotification,
} from "carbon-components-react";
import { UserAvatar32, Login16 } from "@carbon/icons-react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchLogin,
  loginSelector,
  postFLogin,
  postSQuestion,
  postChagePass,
} from "./login-dux";
import {
  fetchTermsAndCondition,
  termsAndConditionSelector,
} from "./termsAndCondition-dux";
import { ContactUs } from "../views/contactUs/contactUs.jsx";
import { Loader } from "../components/common/loader/loader.jsx";

export const Login = (props) => {
  const dispatch = useDispatch();
  const { loginData, loading } = useSelector(loginSelector);
  const { termsAndConditionData, termsLoading } = useSelector(
    termsAndConditionSelector
  );
  const [openTAndC, setOpenTAndC] = useState(false);
  const [openContactUs, setOpenContactUs] = useState(false);
  const [contactToastMessage, setContactToastMessage] = useState("");
  const [activeSection, setActiveSection] = useState("");
  const [secretQuestionData, setSecretQuestionData] = useState("");
  const [showUsernameError, setUsernameError] = useState(false);
  const [showPasswordError, setPasswordError] = useState(false);
  const [resetLoginId, setResetLoginId] = useState("");
  const [invalidUserError, setInvalidUserError] = useState(false);
  const [errorState, setErrorState] = useState(true);
  const [toast, setToast] = useState(false);
  const [toastContent, setToastContent] = useState("");
  const [toastKind, setToastKind] = useState(true);

  useEffect(() => {
    dispatch(fetchLogin());
    dispatch(fetchTermsAndCondition());
  }, [dispatch]);

  useEffect(() => {
    !loading && loginData.data.divToShow
      ? setActiveSection(loginData.data.divToShow)
      : setActiveSection("");
  }, [!loading, loginData]);

  useEffect(() => {
    setErrorState(errorState);
  }, [setErrorState]);

  const onHandleTAndCModal = () => {
    setOpenTAndC(!openTAndC);
  };

  const onHandleContactUsModal = () => {
    setOpenContactUs(!openContactUs);
    setContactToastMessage("");
  };

  const onhandleButton = (url) => {
    window.location.href = url;
  };

  const onHandleActive = (activeSection) => {
    setActiveSection(activeSection);
  };

  const handleLanguageSelection = (e) => {
    console.log(e.selectedItem.code);
    window.location = window.location.pathname+"?cmsLocaleCode="+e.selectedItem.code;
  }

  const onSubmitFLogin = async (event) => {
    let result = await postFLogin(event);
      if (result.data.valid) {
        setActiveSection("SECURITY_QUESTION");
        setSecretQuestionData(result.data);
        setToast(false);
        setToastKind(false);
        setToastContent("");
		setResetLoginId("");
        setResetLoginId("");
        setInvalidUserError(false);
      } else {
        setToastContent(result.data.errorMsg ? result.data.errorMsg : "");
        setResetLoginId(event);
        setInvalidUserError(true);
      }
  };

  const onLoginSubmitForm = async (event) => {
    event.preventDefault();
    if(j_username.value == '') {
      setUsernameError(true)
    }else {
      setUsernameError(false);
    }
    if(j_password.value == '') {
      setPasswordError(true)
    }else {
      setPasswordError(false);
    }

    if(j_username.value != '' && j_password.value != '' ) {
      document.getElementById("loginForm").submit();
    }

  };

  const onSubmitSQuestion = async (event) => {
    let result = await postSQuestion(event);
    if (result && result.data) {
      if (result.data.valid) {
        window.location.href = location.origin + result.data.redirectUrl;
        //setActiveSection('CHANGE_PASSWORD');
        //setChangePassData(result.data);
        ////setToast(false);
        //setToastKind(false);
        //setToastContent('');
      } else {
        setToastContent(result.data.errorMsg ? result.data.errorMsg : "");
        setToastKind(false);
        setToast(true);
      }
    }
  };

  const onSubmitChagePass = async (newPassword, sq, secretAnswer, collectSecretDetailsOnly) => {
    let result = await postChagePass(newPassword, sq, secretAnswer, collectSecretDetailsOnly);
    if (result && result.data) {
      if (result.data.valid) {
        setActiveSection("");
        setToast(true);
        setToastKind(true);
        setToastContent(
          result.data.changedPassword
            ? result.data.responseMsg
            : "Password Changed"
        );
      } else {
        setActiveSection("CHANGE_PASSWORD");
        setToastContent(result.data.errorMsg ? result.data.errorMsg : "");
        setToastKind(false);
        setToast(true);
      }
    }
  };

  const onhandleToast = () => {
    setToast(false);
    setToastKind(false);
    setToastContent("");
  };

  const RenderActiveSection = (data) => {
    switch (activeSection) {
      case "RESET_PASSWORD":
        return (
          <ResetPassword
            data={data.loginData}
            activeSection={data.onHandleActive}
            onSubmitFLogin={data.onSubmitFLogin}
			resetLoginId={data.resetLoginId}
          />
        );
        break;
      case "SECURITY_QUESTION":
        return (
          <SecurityQuestion
            data={data.loginData}
            activeSection={data.onHandleActive}
            secretQuestionData={data.secretQuestionData}
            onSubmitSQuestion={data.onSubmitSQuestion}
          />
        );
        break;
      case "CHANGE_PASSWORD":
        return (
          <LoginChangePassword
            data={data.loginData}
            activeSection={data.onHandleActive}
            changePassData={data.loginData}
            onSubmitChagePass={data.onSubmitChagePass}
          />
        );
        break;
    }
  };

  return (
    <div className="login-container">
      {!loading && !termsLoading ? (
        <div className="bx--row">
          <div className="bx--col-sm-6 bx--col-sm-8 bx--col-md-12 bx--col-lg-7 bx--no-gutter info-block-outer">
            {toast ? (
              <ToastNotification
                iconDescription="close button"
                title={""}
                subtitle={
                  toastContent ? (
                    <span dangerouslySetInnerHTML={{ __html: toastContent }} />
                  ) : (
                    ""
                  )
                }
                kind={toastKind ? "success" : "error"}
                size="small"
                onCloseButtonClick={onhandleToast}
              />
            ) : (
              ""
            )}
            {contactToastMessage !='' &&
              <ToastNotification
                iconDescription="close button"
                title={""}
                subtitle={
                  contactToastMessage ? (
                    <span dangerouslySetInnerHTML={{ __html: contactToastMessage }} />
                  ) : (
                    ""
                  )
                }
                kind={"success"}
                size="small"
                onCloseButtonClick={onhandleToast}
              />
            }
            <div className="info-block">
              <DropdownItem loginData={loginData} handleLanguageSelection={handleLanguageSelection} />
              <div className="login-heading">
                <h1 className="welcome-text">
                  {loginData.data.loginCM.WELCOME_TEXT}
                </h1>
                <h1 className="ft-light">
                  {loginData.data.loginCM.IBM_LBL}{" "}
                  <span className="ft-bold">
                    {loginData.data.loginCM.REC_CENTER_LBL}
                  </span>
                </h1>
              </div>
              <div className="body-content">
                <span dangerouslySetInnerHTML={{ __html: loginData.data.loginCM.LOGIN_MESSAGE_LBL }} />
              </div>
              <div className="login-link">
              <span dangerouslySetInnerHTML={{ __html: loginData.data.loginCM.CURRENT_EMP_LBL }} />{" "}
                <Link href={loginData.data.ibmLoginUrl}>
                  {loginData.data.loginCM.LOGIN_THROUGH_W3}
                </Link>
              </div>
              <div className="footer-links show-desk">
                <p className="link ft-14" onClick={() => onHandleTAndCModal()}>
                  {loginData.data.loginCM.T_AND_C_LBL}
                </p>
                <p
                  className="link ft-14"
                  onClick={() => onHandleContactUsModal()}
                >
                  {loginData.data.loginCM.CONTACT_US_LBL}
                </p>
              </div>
            </div>
          </div>
          <div className="bx--col-sm-6 bx--col-md-12 bx--col-lg-5 form-block-outer">
            <div className="form-block">
              {activeSection == "" ? (
                <div className="form-container">
                  <div className="form-heading-container">
                    <div className="form-heading">{loginData.data.loginCM.LOGIN_LABEL}</div>
                    <p className="login-link ft-12">
                      {loginData.data.loginCM.LOGIN_W3_BTN_LBL}
                    </p>
                    <Button
                      size="lg"
                      className="login-btn lg"
                      onClick={() => onhandleButton(loginData.data.ibmLoginUrl)}
                      renderIcon={UserAvatar32}
                      iconDescription={loginData.data.loginCM.LOGIN_W3_BTN_LBL}
                    >
                      {loginData.data.loginCM.LOGIN_W3_BTN_LBL}
                    </Button>
                  </div>
                  <div className="login-text-border">
                    <span>or</span>
                  </div>
                  <p className="ft-14">
                    {loginData.data.loginCM.FORMER_EMP_MSG_LBL
                      ? <span dangerouslySetInnerHTML={{ __html: loginData.data.loginCM.FORMER_EMP_MSG_LBL }} />
                      : ""}
                  </p>
                  <div className="form-content-section">
                    {loginData.data.error && errorState ? (
                      <InlineNotification
                        kind="error"
                        title={loginData.data.error}
                        lowContrast
                        hideCloseButton
                      />
                    ) : (
                      ""
                    )}
                    <Form
                      onSubmit={onLoginSubmitForm}
                      action={loginData.data.loginUrl}
                      method="post"
                      id="loginForm"
                    >
                      <div className="username input-text">
                        <label htmlFor="username" className="bx--label">
                          {loginData.data.loginCM.LOGIN_ID_LBL}*
                          <span
                            className="link forgot-link"
                            onClick={() => onHandleContactUsModal()}
                          >
                            {loginData.data.loginCM.RETRIEVE_YOUR_LOGINID_LBL}
                          </span>
                        </label>
                        <input
                          type="hidden"
                          name="csrfPreventionSalt"
                          value={loginData.data.csrrToken}
                        />
                        <TextInput
                          id="j_username"
                          labelText={loginData.data.loginCM.LOGIN_ID_LBL}
                          invalidText="Username cannot be empty"
                          name="j_username"
                          invalid={showUsernameError}
                          helperText={loginData.data.loginCM.LOGIN_ID_LBL}
                        />
                      </div>
                      <div className="password input-text">
                        <label htmlFor="password" className="bx--label">
                          {loginData.data.loginCM.PASSWORD_LBL}*
                          <span
                            className="link forgot-link"
                            onClick={(e) => {setActiveSection("RESET_PASSWORD"); setErrorState(false); setInvalidUserError(false); setResetLoginId(""); }}
                          >
                            {loginData.data.loginCM.RESET_YOUR_PWD_LBL}
                          </span>
                        </label>
                        <PasswordInput
                          id="j_password"
                          labelText={loginData.data.loginCM.PASSWORD_LBL}
                          name="j_password"
                          invalidText="Password cannot be empty"
                          invalid={showPasswordError}
                        />
                      </div>
                      <div className="button-container">
                        <Button
                          id="loginBtn"
                          className="login-btn"
                          type="submit"
                          renderIcon={Login16}
                          iconDescription={loginData.data.loginCM.LOGIN_BTN_LBL}
                        >
                          {" "}
                          {loginData.data.loginCM.LOGIN_BTN_LBL}
                        </Button>
                      </div>
                    </Form>
                  </div>
                </div>
              ) : (
                <div className="password-reset-wrapper">
                  <p
                    className="back-to-login ft-14"
                    onClick={(e) => {setActiveSection(""); setErrorState(false); setInvalidUserError(false); setResetLoginId(""); }}
                  >
                    {loginData.data.loginCM.BACK_TO_LOGIN}
                  </p>
                  {(loginData.data.error && errorState) || invalidUserError ? (
                    <InlineNotification
                      kind="error"
                      title={invalidUserError ? toastContent : loginData.data.error}
                      lowContrast
                      hideCloseButton
                    />
                  ) : (
                    ""
                  )}
                  <RenderActiveSection
                    loginData={loginData}
                    onHandleActive={onHandleActive}
                    onSubmitFLogin={onSubmitFLogin}
                    secretQuestionData={secretQuestionData}
                    onSubmitSQuestion={onSubmitSQuestion}
                    changePassData={loginData}
                    onSubmitChagePass={onSubmitChagePass}
					resetLoginId={resetLoginId}
                  />
                </div>
              )}
            </div>

          </div>
          <div className="footer-links show-mob">
                <p className="link ft-14" onClick={() => onHandleTAndCModal()}>
                  {loginData.data.loginCM.T_AND_C_LBL}
                </p>
                <p
                  className="link ft-14"
                  onClick={() => onHandleContactUsModal()}
                >
                  {loginData.data.loginCM.CONTACT_US_LBL}
                </p>
              </div>
                {openTAndC && (
                  <TAndCItem
                    termsAndConditionData={termsAndConditionData}
                    openTAndC={openTAndC}
                    onHandleTAndCModal={() => onHandleTAndCModal()}
                  />
                )}

                {openContactUs && (
                  <ContactUs
                    setOpenContactUs={setOpenContactUs}
                    openContactUs={openContactUs}
                    onHandleContactUsModal={onHandleContactUsModal}
                    setContactToastMessage={setContactToastMessage}
                  />
                )}
        </div>
      ): <Loader /> }
    </div>
  );
};

const DropdownItem = (props) => {
  const item =
    props.loginData.data.languagesList && props.loginData.data.languagesList;
    const {handleLanguageSelection} = props;
    const selectedLanguage = window.location.href.split("=")[1];
  return (
    <div className="lang-selection-wrapper">
      <div className="lang-icon">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 32 32" enableBackground="new 0 0 32 32" width="16px">
          <path fill="#FFFFFF" d="M29.039,22.668l-3.101-8.847H21.8l-2.186,6.274l-3.451,9.876h3.647l1.158-4.037h5.822l1.156,4.037h3.649
            L29.039,22.668z M21.82,23.241c0.313-1.009,0.593-1.927,0.837-2.731c0.646-2.117,1.054-3.517,1.228-4.191
            c0.058,0.262,0.155,0.616,0.29,1.067c0.104,0.349,0.482,1.58,1.135,3.689c0.2,0.64,0.424,1.381,0.672,2.166H21.82z"/>
          <rect x="0.485" y="3.73" fill="#FFFFFF" width="17.249" height="2.731"/>
          <path fill="#FFFFFF" d="M16.659,19.61c-6.098-1.104-9.396-4.113-11.087-6.442C3.752,10.665,3.364,8.42,3.348,8.326l2.699-0.274
            l-1.35,0.137l1.35-0.14c0.003,0.02,0.355,1.987,1.938,4.133c2.072,2.81,5.197,4.611,9.289,5.354L16.659,19.61z"/>
          <path fill="#FFFFFF" d="M1.604,19.61l-0.614-2.649c4.091-0.948,7.215-3.249,9.287-6.838c1.583-2.741,1.936-5.252,1.939-5.277
            l2.698,0.353c-0.015,0.12-0.403,2.988-2.222,6.185C10.999,14.358,7.701,18.199,1.604,19.61z"/>
          <rect x="7.807" y="1" fill="#FFFFFF" width="2.605" height="3.971"/>
        </svg>
      </div>
      <Dropdown
        light
        type="inline"
        items={item}
        itemToString={(item) => (item ? item.name : "")}
        id="lang"
        label={"language selection"}
        titleText={"language selection"}
        className="lang-selection"
        onChange={handleLanguageSelection}
        selectedItem={selectedLanguage == 'fr_CA' ? item[1] : item[0]}
      />
    </div>
  );
};

const TAndCItem = (props) => {
  let tAndC = props.termsAndConditionData;
  return (
    <>
      <Modal
        modalHeading={tAndC.data.pageTitle}
        modalLabel=""
        passiveModal={true}
        open={props.openTAndC}
        onRequestClose={props.onHandleTAndCModal}
        className="login-tc login-modal"
      >
        {tAndC.data.termsAndConditions.map((cat, key) => {
          return (
            <Accordion align="end" key={key}>
              <AccordionItem title={cat.title}>
                <p dangerouslySetInnerHTML={{ __html: cat.content }} />
              </AccordionItem>
            </Accordion>
          );
        })}
        <div className="bx--modal-content--overflow-indicator"></div>
      </Modal>
    </>
  );
};

const ResetPassword = (props) => {
  const [userName, setUserName] = useState("");
  const {resetLoginId} = props;
  const data = props.data.data && props.data.data;

  return (
    <div className="password-reset-inner-wrapper">
      <div className="ft-18 gray-100 heading">
        {data.loginCM.RESET_YOUR_PWD_LBL}
      </div>
      <div className="form-content-section">
        <div className="input-text input-wrapper">
          <TextInput
            id="userName"
            labelText={data.loginCM.LOGIN_ID_LBL + "*"}
            required
            name="userName"
            onChange={(e) => setUserName(e.target.value)}
			defaultValue={resetLoginId}
            helperText={data.loginCM.LOGIN_ID_LBL}
          />
        </div>
      </div>
      <div className="button-container">
        <Button
          kind="secondary"
          className="cancel-btn"
          onClick={() => props.activeSection("")}
        >
          {data.loginCM.CANCEL}
        </Button>
        <Button
          className="continue-btn"
          onClick={() => props.onSubmitFLogin(userName)}
        >
          {data.loginCM.CONTINUE}
        </Button>
      </div>
    </div>
  );
};

const SecurityQuestion = (props) => {
  const [sQuestion, setSQuestion] = useState("");
  const content = props.secretQuestionData && props.secretQuestionData;
  const data = props.data.data && props.data.data;
  return (
    //content &&
    <div className="password-reset-inner-wrapper">
      <div className="ft-18 gray-100 heading mb-04">
        {data.loginCM.SECURITY_QUESTION}
      </div>
      <div className="sub-heading">
        {data.divToShow ? data.secretQuestion : content.secretQuestion}
      </div>
      <div className="form-content-section">
        <div className="input-text input-wrapper">
          <TextInput
            id="secretAnswer"
            labelText={data.loginCM.YOUR_ANSWER + "*"}
            name="secretAnswer"
            onChange={(e) => setSQuestion(e.target.value)}
            helperText={data.loginCM.YOUR_ANSWER}
          />
        </div>
      </div>
      <div className="button-container">
        <Button
          kind="secondary"
          className="cancel-btn"
          onClick={() => props.activeSection("RESET_PASSWORD")}
        >
          {data.loginCM.CANCEL}
        </Button>
        <Button
          className="continue-btn"
          onClick={() => props.onSubmitSQuestion(sQuestion)}
        >
          {data.loginCM.CONTINUE}
        </Button>
      </div>
    </div>
  );
};

const LoginChangePassword = (props) => {
  const content = props.data.data && props.data.data;
  const [secretAnswer, setSecretAnswer] = useState(
    content.secretAnswer ? content.secretAnswer : ""
  );
  const [sq, setSq] = useState(
    content.secretQuestionList ? content.secretQuestionList[0] : ""
  );
  const [newPassword, setNewPassword] = useState("");
  const data = props.data.data && props.data.data;
  return (
    content && (
      <div className="password-reset-inner-wrapper">
        <div className="ft-18 gray-100 heading mb-04">
          {content.loginCM.CHANGE_PASSWORD}
        </div>
        <div className="sub-heading">
          {content.loginCM.CHANGE_PASSWORD_DESC}
        </div>
        <div className="form-content-section">
          {!content.collectSecretDetailsOnly &&
            <>
              <div className="password input-text input-wrapper">
                <TextInput
                  id="newPassword"
                  type="password"
                  labelText={content.loginCM.NEW_PASSWORD + "*"}
                  name="newPassword"
                  onChange={(e) => setNewPassword(e.target.value)}
                  helperText={content.loginCM.NEW_PASSWORD}
                />
              </div>
              <div className="confirm-password input-text input-wrapper">
                <TextInput
                  id="confirmPassword"
                  type="password"
                  labelText={content.loginCM.CONFIRM_NEW_PASSWORD + "*"}
                  name="confirmPassword"
                  helperText={content.loginCM.CONFIRM_NEW_PASSWORD}
                />
              </div>
            </>
          }
          <div className="sub-heading">
            {content.loginCM.CHANGE_SECURITY_QUESTION}
          </div>

          <div className="security-question input-text input-wrapper">
            <Dropdown
              //light type="inline"
              items={content.secretQuestionList}
              //initialSelectedItem={ content.secretQuestionList[0] }
              itemToString={(item) => (item ? item.name : "")}
              id="secirityQuestion"
              titleText={content.loginCM.SECURITY_QUESTION}
              label={content.loginCM.SECURITY_QUESTION}
              onChange={({ selectedItem }) => setSq(selectedItem)}
              selectedItem={sq}
            />
          </div>

          <div className="answer input-text input-wrapper">
            <TextInput
              id="secretAnswer"
              labelText={content.loginCM.YOUR_ANSWER + "*"}
              name="secretAnswer"
              onChange={(e) => setSecretAnswer(e.target.value)}
              value={secretAnswer}
              helperText={content.loginCM.YOUR_ANSWER}
            />
          </div>
        </div>
        <div className="button-container">
          <Button
            kind="secondary"
            className="cancel-btn"
            onClick={() => props.activeSection("SECURITY_QUESTION")}
          >
            {data.loginCM.CANCEL}
          </Button>
          <Button
            className="continue-btn"
            onClick={() =>
              props.onSubmitChagePass(newPassword, sq.code, secretAnswer, content.collectSecretDetailsOnly)
            }
          >
            {data.loginCM.CONTINUE}
          </Button>
        </div>
      </div>
    )
  );
};
